import { translate } from "react-switch-lang";
import React, { useState } from "react";
import { Card, Media } from "reactstrap";
import styles from "./thematicFolderCard.module.scss";
import ClickAwayListener from "react-click-away-listener";
import { ThematicFolderDto } from "../../../models/ThematicFolderDto";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import keycloak from "../../../security/keycloak-config";
import hasRoles from "../../../security/hasRoles";

const ThematicFolderCard: React.FC<{
  t: (key: string) => {};
  data: ThematicFolderDto;
  handleUpdateThematicFolder: (data: ThematicFolderDto) => void;
  handleRemoveThematicFolder: (id: number) => void;
  handleGetListFolderThematic: (id: number) => void;
  handleClickThematicFolder: (id: number) => void;
}> = ({ t, data, handleUpdateThematicFolder, handleRemoveThematicFolder, handleClickThematicFolder }) => {
  const selectedLanguage = useSelector((state: RootState) => state.language.currentLang);
  const [langdropdown, setLangdropdown] = useState(false);
  const hasRoleAdmin = hasRoles(["ROLE_MEDIATHEQUE_ADMIN"], keycloak);
  const [elementSelected, setElementSelected] = useState<ThematicFolderDto>(new ThematicFolderDto());

  const handleSetDropDown = () => {
    setLangdropdown(!langdropdown);
  };

  return (
    <>
      <Card className={styles["card-document"]}>
        <div className={styles["card-style"] + " blog-box blog-grid text-center product-box"}>
          <div className="product-img text-center">
            <Media className={styles["img-card"] + " img-fluid top-radius-blog"} src={data.urlImage + ""} alt="" />
            <div className="product-hover">
              <ul>
                <li onClick={() => handleClickThematicFolder(data.thematicFolderId)}>
                  <i className="icon-eye"></i>
                </li>
              </ul>
            </div>
          </div>

          <div className="blog-details-main">
            <h6 title={selectedLanguage === "en" ? data.titleAnglais : data.titleFrancais} className={styles["title-card"] + " blog-bottom-details"}>
              {selectedLanguage === "en" ? data.titleAnglais : data.titleFrancais}
            </h6>
            <hr />
            <ul className="blog-social">
              <li className="digits">
                <i className={styles["icon-flad"] + " fa fa-tag " + styles["fa-tags"]}></i> {t("label_thematic_folder")}
              </li>
              {hasRoleAdmin && (
                <li className="digits">
                  <ClickAwayListener
                    onClickAway={() => {
                      handleSetDropDown();
                      setElementSelected(new ThematicFolderDto());
                    }}
                  >
                    <div className={`${styles["translate_wrapper"]} ${langdropdown && elementSelected.thematicFolderId === data.thematicFolderId ? styles["active"] : ""}`}>
                      <div className={styles["current_lang"]}>
                        <div
                          className={styles["lang"]}
                          onClick={() => {
                            setElementSelected(data);
                            handleSetDropDown();
                          }}
                        >
                          <i className="fa fa-gear"></i>
                        </div>
                      </div>

                      <div className={`${styles["more_lang"]} ${langdropdown ? styles["active"] : ""}`}>
                        <div
                          className={styles["lang"]}
                          onClick={event => {
                            event.stopPropagation();
                            handleSetDropDown();
                            // handleClickOpenModalEditSupport(data);
                            handleUpdateThematicFolder(data);
                          }}
                        >
                          <i className={styles["icon-dropdown"] + " flag-icon fa fa-edit " + styles["icon-update"]}></i>
                          <span className={styles["lang-txt"]}>{t("button_update")}</span>
                        </div>
                        <div
                          className={styles["lang"]}
                          onClick={event => {
                            handleSetDropDown();
                            event.stopPropagation();
                            // handleDeleteSUpportVideo(data.supportId);
                            handleRemoveThematicFolder(data.thematicFolderId);
                          }}
                        >
                          <i className={styles["icon-dropdown"] + " flag-icon fa fa-trash " + styles["icon-delete"]}></i>
                          <span className={styles["lang-txt"]}>{t("button_delete")}</span>
                        </div>
                      </div>
                    </div>
                  </ClickAwayListener>
                </li>
              )}
            </ul>
          </div>
        </div>
      </Card>
    </>
  );
};

export default translate(ThematicFolderCard);
